"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotionPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const hooks_1 = require("../../hooks");
function MotionPanel(props) {
    const { className } = props;
    const state = (0, hooks_1.useMotionPanelState)();
    const bridge = (0, bridge_1.useBridge)();
    const [lockSlider, setLockSlider] = (0, react_1.useState)(false);
    const onChange = (0, react_1.useCallback)((value) => {
        if (value == null || Array.isArray(value)) {
            return;
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.motionAnimationMovementValueChangeAction({
            value: value,
        });
    }, [bridge]);
    const onButtonClick = (0, react_1.useCallback)(() => {
        (state === null || state === void 0 ? void 0 : state.isPaused)
            ? bridge === null || bridge === void 0 ? void 0 : bridge.motionAnimationPlayAction()
            : bridge === null || bridge === void 0 ? void 0 : bridge.motionAnimationPauseAction();
    }, [state, bridge]);
    if (!state) {
        return null;
    }
    const { articulationLabel, rangeOfMotionLabel, isMovementVisible, movementLabel, movementValue, isPaused, sliderValue, } = state;
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'MotionPanel_Container', children: [(0, jsx_runtime_1.jsxs)(Top, { "data-e2e": 'MotionPanel_Top', children: [(0, jsx_runtime_1.jsxs)(SliderContainer, { "data-e2e": 'MotionPanel_SliderContainer', children: [(0, jsx_runtime_1.jsx)(StyledButton, { onClick: onButtonClick, "data-e2e": 'MotionPanel_StyledButton', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: isPaused ? ui_1.Icons.Play : ui_1.Icons.Pause, "data-e2e": 'MotionPanel_ButtonIcon' }) }), (0, jsx_runtime_1.jsx)(StyledSlider, { currentValue: lockSlider ? undefined : sliderValue, onChange: onChange, onBeforeChange: () => setLockSlider(true), onAfterChange: () => setLockSlider(false), "data-e2e": 'MotionPanel_StyledSlider' })] }), (0, jsx_runtime_1.jsxs)(MovementContainer, { "$visible": isMovementVisible, "data-e2e": 'MotionPanel_MovementContainer', children: [(0, jsx_runtime_1.jsxs)(MovementLabel, { "data-e2e": 'MotionPanel_MovementLabel', children: [movementLabel, ":"] }), (0, jsx_runtime_1.jsx)(MovementLabelContainer, { "data-e2e": 'MotionPanel_MovementLabelContainer', children: movementValue })] })] }), (0, jsx_runtime_1.jsxs)(Bottom, { "data-e2e": 'MotionPanel_Bottom', children: [(0, jsx_runtime_1.jsxs)(LabelsContainer, { "data-e2e": 'MotionPanel_LabelsContainer', children: [(0, jsx_runtime_1.jsx)(TitleLabel, { "data-e2e": 'MotionPanel_TitleLabel', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.motion.articulation) }), (0, jsx_runtime_1.jsx)(ValueLabel, { "data-e2e": 'MotionPanel_ValueLabel', children: articulationLabel })] }), (0, jsx_runtime_1.jsxs)(LabelsContainer, { "data-e2e": 'MotionPanel_LabelsContainer', children: [(0, jsx_runtime_1.jsx)(TitleLabel, { "data-e2e": 'MotionPanel_TitleLabel', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.motion.rangeOfMotion) }), (0, jsx_runtime_1.jsx)(ValueLabel, { "data-e2e": 'MotionPanel_ValueLabel', children: rangeOfMotionLabel })] })] })] }));
}
exports.MotionPanel = MotionPanel;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  width: 100%;
  padding-top: 10px;

  background: ${({ theme }) => theme.motionPanel.background};
  border-radius: 4px;

  ${ui_1.deviceLandscape.mobileS((0, styled_components_1.css) `
    left: 15px;

    width: 100%;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  `)}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    left: auto;
  `)}

  ${ui_1.device.tablet((0, styled_components_1.css) `
    width: 628px;
  `)};
`;
const Top = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  width: 100%;
  height: 70px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    flex-direction: row;

    border-bottom: 1px solid ${({ theme }) => theme.thinLine};
  `)};
`;
const StyledButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  display: flex;
  flex-shrink: 0;
  width: 44px;
  height: 44px;

  margin: 0 10px 0 15px;
  padding: 0;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 70%;
  height: 70%;
`;
const SliderContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  align-items: center;
`;
const StyledSlider = (0, styled_components_1.default)(ui_1.Slider) `
  .track {
    height: 2px;
  }

  .track-0 {
    background-color: ${props => props.theme.gray};
  }

  .thumb {
    width: 16px;
    height: 16px;

    border-color: transparent;
  }
`;
const MovementContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;

  margin-left: 17px;

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};

  transition: opacity 0.3s ease-in-out;
`;
const MovementLabel = styled_components_1.default.div `
  font-weight: bold;
  font-size: 15px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    width: 157px;
    margin: 0 8px;

    text-align: right;
  `)};
`;
const MovementLabelContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;

  font-weight: bold;
  font-size: 22px;
  text-align: center;

  &:after {
    content: '°';
  }
`;
const Bottom = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  width: 100%;

  margin-left: 17px;
`;
const LabelsContainer = styled_components_1.default.div `
  display: flex;
  height: 28px;

  line-height: 28px;
`;
const TitleLabel = styled_components_1.default.div `
  font-weight: bold;
  font-size: 13px;
`;
const ValueLabel = styled_components_1.default.div `
  margin-left: 5px;

  font-size: 13px;
`;
